// extracted by mini-css-extract-plugin
export default {"events":"EventsTab_events__9aRUS","eventsBlock":"EventsTab_eventsBlock__tDn-c","actions":"EventsTab_actions__sLS65"};